import React from 'react';
import { Slider, Radio, Tooltip, InputNumber, Menu, Dropdown, Icon, Button, Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

export default class LengthEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        super.componentWillMount();

        const v = this.props.source.value;
        if (!v)
            this.props.source.value = { mode: "auto", actualValue: "auto" };
    }

    onPercentChange(e) {
        this.props.source.value = {
            mode: "percent",
            value: e,
            actualValue: e + "%",
        };
        this.setState({});
    }

    onPxChange(e) {
        this.props.source.value = {
            mode: "px",
            value: e,
            actualValue: e,
        };
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    onDropDownClick(e) {
        console.log(e);
    }

    onModeChange(e) {
        if (e === "auto") {
            this.props.source.value = {
                mode: "auto", actualValue: "auto"
            };
        }
        else if (e === "px") {
            this.props.source.value = {
                mode: "px",
                value: this.props.source.minValueAbsolute === undefined ? 0 : this.props.source.minValueAbsolute,
                actualValue: this.props.source.minValueAbsolute === undefined ? 0 : this.props.source.minValueAbsolute
            };
        }
        else {
            this.props.source.value = {
                mode: "percent",
                value: this.props.source.minValuePercent === undefined ? 0 : this.props.source.minValuePercent,
                actualValue: (this.props.source.minValuePercent === undefined ? 0 : this.props.source.minValuePercent) + '%'
            };
        }
    }

    render() {

        let value = this.props.source.value;
        if (!value)
            return;

        const mode = value.mode;
        value = value.value;

        const menu = (
            <Menu>
                <Menu.Item key="auto" onClick={e => this.onModeChange("auto")}>自动</Menu.Item>
                <Menu.Item key="px" onClick={e => this.onModeChange("px")}>像素</Menu.Item>
                <Menu.Item key="percent" onClick={e => this.onModeChange("percent")}>比例</Menu.Item>
            </Menu>
        );

        return (
            <div className="property-editor--length">
                <div className="layout-h center hstretch">
                    {
                        mode === "auto" ? <Input
                            className="fill"
                            disabled /> : null
                    }
                    {
                        mode === "percent" ? <InputNumber
                            className="fill"
                            value={value}
                            formatter={value => `${value}%`}
                            parser={value => value.replace('%', '')}
                            min={this.props.source.minValuePercent === undefined ? -1000 : this.props.source.minValuePercent}
                            max={this.props.source.maxValuePercent === undefined ? 1000 : this.props.source.maxValuePercent}
                            onChange={e => this.onPercentChange(e)} /> : null
                    }
                    {
                        mode === "px" ? <InputNumber
                            className="fill"
                            value={value}
                            min={this.props.source.minValueAbsolute === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValueAbsolute}
                            max={this.props.source.maxValueAbsolute === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValueAbsolute}
                            onChange={e => this.onPxChange(e)} /> : null
                    }
                    <Dropdown overlay={menu} trigger={['click']}>
                        <Button
                            className='sp-left btn-bd-focus-none btn-pd-sm btn-layer-node btn-bk-hover btn-bd-none'
                            style={{ padding: '5px 5px' }}>
                            {mode === "auto" ? "自动" : (mode === "px" ? "像素" : "比例")} <DownOutlined type="down" style={{ marginLeft: 3, fontSize: 10 }} />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        );
    }
}

PropertyGridUtils.register("length", (source, propertyGrid) => <LengthEditor source={source} propertyGrid={propertyGrid} />);